import { IExecutionOptions } from '../models/query';
import { Query } from './Query';
import { IQueryOptionsEntities } from '../models/query/options';
import { BaseEntityQuery } from './BaseEntityQuery';

export class EntitiesQuery extends BaseEntityQuery<IQueryOptionsEntities> {
	getOptions(): IQueryOptionsEntities {
		const { entityConditional, entitiesOptions, options = {} } = this.queryOptions;
		const { childQuery } = entitiesOptions || {};
		return {
			entityConditional,
			childQuery,
			...(options.entities || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const entities = this.getEntities(executionOptions);
		const results: any[] = [];
		if (entities && entities.length > 0) {
			const { childQuery } = this.options;

			let options = { ...this.queryOptions };
			if (childQuery) {
				options = childQuery;
				if (!childQuery.entityType) {
					const entityType = entities[0].type;
					options.entityType = entityType;
				}
				const query = new Query(options, this.translationHelper);
				for (const entity of entities) {
					const overrideExecutionOptions: IExecutionOptions = {
						context: {
							entityByType: {
								[options.entityType]: entity,
							},
						},
					};
					const workingExecutionOptions = query.mergeExecutionOptions(executionOptions, overrideExecutionOptions || {});
					const result = query.execute(workingExecutionOptions);
					if (result) {
						results.push(result);
					}
				}
			}
			else {
				// Default to return whole entity if no childQuery is defined.
				return entities as any;
			}
		}
		return results as any;
	}
}